import ClientService from '../../services/client-service';
import getActivityDataQuery from '../../graphql/query/get-activity-data.graphql';
import saveActivityDataMutation from '../../graphql/mutation/save-activity-data.graphql';
import deleteActivityCommentMutation from '../../graphql/mutation/delete-activity-comment.graphql';
import saveActivityCommentMutation from '../../graphql/mutation/save-activity-comment.graphql';
import saveActivityStatusMutation from '../../graphql/mutation/save-activity-status.graphql';

export default class ActivityApi {
  public static getActivityData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getActivityDataQuery, payload);
  }

  public static saveActivityData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveActivityDataMutation, payload);
  }

  public static deleteActivityComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteActivityCommentMutation, payload);
  }

  public static saveActivityComment(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveActivityCommentMutation, payload);
  }

  public static saveActivityStatus(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveActivityStatusMutation, payload);
  }
}
